import { all, call, put, takeEvery, select } from 'redux-saga/effects'
import { productActions } from '@redux/store/index'
import { bomApi, ResType } from '@api'
import { Bom, BomType, BomBatchUpdateType } from '@schemas'
import type { PayloadAction } from '@reduxjs/toolkit'

// API call to fetch BOM
const apiGetBom = async (productId: string): Promise<ResType | undefined> => {
	const res = await bomApi.getBOM({ query: { productId } })
	return res
}

const batchUpdateBOM = async (
	bomList: BomBatchUpdateType[],
): Promise<ResType | undefined> => {
	const response = await bomApi.batchUpdateBOM({ body: { bomList } })
	return response
}

// Separate function to handle the fetching logic
function* bomListSaga(action: PayloadAction<string>) {
	try {
		const apiRes: ResType = yield call(apiGetBom, action.payload)

		if (apiRes.status === 200) {
			const data = apiRes.data as any[]
			const bomList = data.map(aData => new Bom(aData))

			bomList.sort((a: BomType, b: BomType) => {
				if (a.manufacturer === 'Judahs' && a.name === 'Margin') {
					return 1
				} else if (b.manufacturer === 'Judahs' && b.name === 'Margin') {
					return -1
				} else if (a.manufacturer === 'Judahs') {
					return 1
				} else if (b.manufacturer === 'Judahs') {
					return -1
				} else if (a.jlcpcbNumber === '' && b.jlcpcbNumber === '') {
					if (a.unitUsd * a.quantity > b.unitUsd * b.quantity) {
						return -1
					} else if (a.unitUsd * a.quantity < b.unitUsd * b.quantity) {
						return 1
					}
				} else if (a.jlcpcbNumber === '') {
					return 1
				} else if (b.jlcpcbNumber === '') {
					return 1
				} else if (a.unitUsd * a.quantity > b.unitUsd * b.quantity) {
					return -1
				} else if (a.unitUsd * a.quantity < b.unitUsd * b.quantity) {
					return 1
				}

				return 0
			})
			yield put(productActions.SET_BOM_LIST(bomList))
		}
	} catch (error: any) {
		console.error('Error fetching BOM:', error)
	}
}

// Saga to handle the batch update action
const batchUpdateBOMSaga = function* (
	action: PayloadAction<BomBatchUpdateType[]>,
): Generator {
	try {
		yield call(batchUpdateBOM, action.payload)
		// Get the selected product ID from the state
		const selectedProductId = yield select(state => state.product.selectedProduct?.id)
		if (selectedProductId) {
			// Fetch BOM for the selected product after updating
			yield put(productActions.FETCH_BOM(selectedProductId as string))
		}
	} catch (error: any) {
		console.error('Error updating BOM:', error)
	}
}

// Watcher saga
export function* watchFetchBOM() {
	yield takeEvery(productActions.FETCH_BOM.type, bomListSaga)
}

export function* watchBatchUpdateBOM() {
	yield takeEvery(productActions.BATCH_UPDATE_BOM.type, batchUpdateBOMSaga)
}

export default function* bomSaga() {
	yield all([watchFetchBOM(), watchBatchUpdateBOM()])
}
